import { Model as e } from "../../../../model.js";
class i extends e {
  constructor(t) {
    super(), this.design = t.design, this.text = t.text;
  }
}
export {
  i as KioskConfigurationServiceModel
};
//# sourceMappingURL=kioskConfigurationService.model.js.map
